"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _designTokens = require("@decisiv/design-tokens");

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var FooterWrapper = (0, _styledComponents.default)(_utils.Wrapper).withConfig({
  displayName: "Foot__FooterWrapper",
  componentId: "sc-9psdmo-0"
})(["border-top:2px solid ", ";"], (0, _toColorString.default)(_designTokens.color.opacity.charcoal15));

function Foot(_ref) {
  var Footer = _ref.footer,
      kind = _ref.kind,
      rest = _objectWithoutProperties(_ref, ["footer", "kind"]);

  if (!Footer) {
    return null;
  }

  return _react.default.createElement(FooterWrapper, {
    kind: kind
  }, _react.default.createElement(Footer, rest));
}

var _default = Foot;
exports.default = _default;